import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
});

export default function MediaCard() {
  const classes = useStyles();

  function clickHandler(event) {
    location.href = "https://www.getnotify.me/";
  }

  return (
    <Card className={classes.root}>
      <CardActionArea onClick = {clickHandler}>
        <CardMedia
          className={classes.media}
          image="https://www.getnotify.me/static/media/echo-message.565cf9b3.gif"
          title="Get Notify Me"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            Alexa Notify Me
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            Send messages to your Alexa device directly from the website or using a free developer API.
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" color="primary" onClick = {clickHandler}>
          Visit
        </Button>
      </CardActions>
    </Card>
  );
}
